import svgUrl from "ni:svgr;LPTODUPcStoHefqUlCcWFkayqQfCD-LnfXLKewQPVyQ";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SvgReset = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3.146 3.146a.5.5 0 0 1 .708 0L8 7.293l4.146-4.147a.5.5 0 0 1 .708.708L8.707 8l4.147 4.146a.5.5 0 0 1-.708.708L8 8.707l-4.146 4.147a.5.5 0 0 1-.708-.708L7.293 8 3.146 3.854a.5.5 0 0 1 0-.708Z" fill="currentColor" /></svg>;
const Memo = memo(SvgReset);
export { Memo as ReactComponent };